module.exports = __webpack_public_path__ + "hashed/assets/spinner.431b7fae.gif";